<template>
  <div class="global-header-widgets">
    <HeaderRates />
    <CommissionCalculatorModal class="global-header-widgets__calculator" />
    <NotificationBell v-if="isSuperadmin" class="global-header-widgets__bell" />
  </div>
</template>
<script>
import { mapState } from "vuex";
import NotificationBell from "./NotificationBell.vue";
import CommissionCalculatorModal from "./CommissionCalculatorModal.vue";
import HeaderRates from "./HeaderRates.vue";
export default {
  name: "GlobalHeaderWidgets",
  components: { NotificationBell, CommissionCalculatorModal, HeaderRates },
  computed: {
    ...mapState("auth", ["session"]),
    isSuperadmin() {
      // Везде в проекте суперадмин-гейт — session.type <= -1 (balances.vue,
      // credentials.vue, valutes.vue, Balances/index.vue), не строгое
      // равенство: тип может быть < -1 у более высоких админ-уровней.
      return !!this.session && this.session.type <= -1;
    }
  }
};
</script>
<style scoped>
/* Раньше калькулятор/колокольчик/тикер жили внутри PageHeader.vue, которую
   каждая страница рендерит у себя в шаблоне заново — при переходе между
   страницами (SPA-роутинг) старый компонент уничтожался, новый монтировался
   с нуля, и введённые в калькуляторе значения молча терялись. Здесь же, как
   и SideMenu.vue, рендерится ОДИН раз в App.vue рядом с router-view — не
   пересоздаётся при смене страницы, состояние переживает навигацию.
   position:fixed напрямую (не внутри .header) — визуально занимает то же
   место, что раньше (тот же height:60px/z-index-совместимая полоса сверху),
   но независимо от конкретной страницы под ней. */
.global-header-widgets {
  position: fixed;
  top: 0;
  right: 0;
  height: 60px;
  z-index: 6;
  pointer-events: none;
}
.global-header-widgets > * {
  pointer-events: auto;
}
.global-header-widgets__bell {
  /* SideMenu.vue's hamburger toggle sits at position:fixed; top:5px;
     right:13px; width:28px — clear of it with margin to spare. */
  position: absolute;
  right: 60px;
  top: 50%;
  transform: translateY(-50%);
}
.global-header-widgets__calculator {
  /* Левее колокольчика (right:60px) — виден всем, не только суперадминам,
     поэтому не может просто идти "перед" ним во flex-потоке: колокольчик
     иногда вообще не рендерится. */
  position: absolute;
  right: 100px;
  top: 50%;
  transform: translateY(-50%);
}
</style>



// WEBPACK FOOTER //
// src/components/ui/GlobalHeaderWidgets.vue